import { formatCpf } from "utils/federal-tax-id";
import { EstadoDaVersao, IDocumentoColaborador, OrigemDocumento } from "./types";

export const ORIGEM_LABEL: Record<OrigemDocumento, string> = {
  APP_INCLUSAO: "Inclusão",
  APP_EXCLUSAO: "Exclusão",
  APP_ALTERACAO: "Alteração",
  CAMPANHA: "Campanha",
  CARGA_INICIAL: "Carga inicial",
};

const ESTADO_LABEL: Record<EstadoDaVersao, string> = { VIGENTE: "Vigente", SUBSTITUIDA: "Substituída", INVALIDADA: "Invalidada" };

export const estadoDe = (r: IDocumentoColaborador): EstadoDaVersao => r.estado ?? (r.versaoVigente ? "VIGENTE" : "SUBSTITUIDA");

const formatEstado = (r: IDocumentoColaborador) => {
  const estado = estadoDe(r);
  return estado === "INVALIDADA" && r.motivoInvalidacao ? `Invalidada (${r.motivoInvalidacao})` : ESTADO_LABEL[estado];
};

const BRT = "America/Sao_Paulo";

export const formatDataHora = (iso: string | null) =>
  iso ? new Date(iso).toLocaleString("pt-BR", { timeZone: BRT, dateStyle: "short", timeStyle: "short" }) : "-";

const formatBaixado = (r: IDocumentoColaborador) => {
  if (!r.baixadoPelaCorretoraEm) return "-";
  const dia = new Date(r.baixadoPelaCorretoraEm).toLocaleDateString("pt-BR", { timeZone: BRT });
  return r.baixadoPor ? `${dia} por ${r.baixadoPor}` : dia;
};

/** Contrato sem número no cadastro: os 8 primeiros caracteres do id, como nas campanhas. */
const formatContrato = (r: IDocumentoColaborador) => r.contrato || r.workspaceId.split("-")[0].toUpperCase();

// why: larguras somadas cabem em 1440 px; flex reparte o que sobra.
export const DOCUMENTO_COLUMNS: {
  field: string;
  header: string;
  width?: number;
  flex?: number;
  minWidth?: number;
  format: (row: IDocumentoColaborador) => string;
}[] = [
  { field: "nome", header: "Nome", flex: 1.3, minWidth: 140, format: (r) => r.nome || "-" },
  { field: "cpf", header: "CPF", width: 150, format: (r) => formatCpf(r.cpf) },
  { field: "contrato", header: "Contrato", flex: 0.7, minWidth: 90, format: formatContrato },
  { field: "operadora", header: "Operadora", flex: 1, minWidth: 150, format: (r) => r.operadora || "-" },
  { field: "tipo", header: "Documento", flex: 1.1, minWidth: 130, format: (r) => r.tipo },
  { field: "origem", header: "Origem", width: 100, format: (r) => ORIGEM_LABEL[r.origem] ?? r.origem },
  { field: "enviadoEm", header: "Enviado em", width: 140, format: (r) => formatDataHora(r.enviadoEm) },
  { field: "estado", header: "Estado", flex: 0.9, minWidth: 110, format: formatEstado },
  { field: "baixadoPelaCorretoraEm", header: "Baixado pela corretora", flex: 1.4, minWidth: 250, format: formatBaixado },
];

const digits = (s: string) => s.replace(/\D/g, "");

/** Busca por nome (sem caixa) ou por CPF, com ou sem máscara. */
export function bateBusca(row: IDocumentoColaborador, termo: string): boolean {
  const t = termo.trim();
  if (!t) return true;
  if ((row.nome ?? "").toLowerCase().includes(t.toLowerCase())) return true;
  const d = digits(t);
  return d.length > 0 && digits(row.cpf).includes(d);
}
